/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useRef, useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import ictLogo from '../../assets/images/ICT-Logo-V4-1-1 1 (1).png';
import { Menu } from 'primereact/menu';
import { Paginator } from 'primereact/paginator';
import { Sidebar } from 'primereact/sidebar';
import AddEditFitnessFee from './AddEditFitnessFee';
import { handleGetRequest } from '../../services/GetTemplate';
import { useDispatch } from 'react-redux';
import { ConfirmDialog } from 'primereact/confirmdialog';
import './AddEditFitnessFee.css';
import './FitnessFeeManagement.css';
import DeleteIcon from '../../assets/icons/delete.svg';
import { handleDeleteRequest } from '../../services/DeleteTemplate';
import SuccessLoader from '../../components/SuccessLoader';
import { FilterMatchMode } from 'primereact/api';

function RegistrationFees() {
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [page, setPage] = useState(1);
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editData, setEditData] = useState(null);
    const [editAble, setEditAble] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
            const [filters, setFilters] = useState({
                global: { value: null, matchMode: FilterMatchMode.CONTAINS }
            });
        
            const onGlobalFilterChange = (e) => {
                const value = e.target.value;
                let _filters = { ...filters };
                _filters['global'].value = value;
                setFilters(_filters);
                setGlobalFilterValue(value);
            };
        
             const renderHeader = () => {
                 return (
                     <div className="Global__Header">
                         <span className="block mt-2 md:mt-0 p-input-icon-left">
                             <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search..."/>
                         </span>
                     </div>
                 );
             };
        
             const header = () => renderHeader();
    const dispatch = useDispatch();

    const menuRefs = useRef(new Map());

    const handleDelete = async (row) => {
        setShowSuccess(true);

        try {
            const response = await dispatch(handleDeleteRequest(`/api/fitness/fee/${row.id}`, true, true));

            if (response?.success) {
                setDeleteDialogVisible(false);
                setUserToDelete(null);
                await fetchFeesData(page);
            }
        } catch (error) {
            console.error('Error deleting user:', error);
        } finally {
            setShowSuccess(false);
        }
    };

    const fetchFeesData = async () => {
        setLoading(true);
        try {
            const response = await handleGetRequest(`/api/fitness/fee`, false, false);
            if (response?.success) {
                setTableData(response?.data || []);
                setTotalRecords(response?.data?.length || 0);
            }
        } catch (error) {
            console.error('Error fetching users data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchFeesData(page);
    }, []);

    const actionBodyTemplate = (rowData) => {
        const handleEdit = (row) => {
            setSidebarVisible(true);
            setIsEditing(true);
            setEditData(row);
            setEditAble(true);
        };

        const confirmDelete = (row) => {
            setUserToDelete(row);
            setDeleteDialogVisible(true);
        };

        const items = [
            {
                label: 'Edit',
                icon: 'pi pi-pencil',
                className: ' custom-edit',
                command: () => handleEdit(rowData)
            },
            {
                label: 'Delete',
                icon: 'pi pi-trash',
                className: ' custom-delete',
                command: () => confirmDelete(rowData)
            }
        ];

        // Get or create a unique menu reference for this row
        if (!menuRefs.current.has(rowData.id)) {
            menuRefs.current.set(rowData.id, React.createRef());
        }
        const rowMenuRef = menuRefs.current.get(rowData.id);

        return (
            <div>
                <Menu model={items} popup ref={rowMenuRef} />
                <Button
                    icon="pi pi-ellipsis-h"
                    className="p-button p-0 m-0 bg-white border-none shadow-none hover:bg-gray-100 custom-icon-black"
                    style={{ boxShadow: 'none' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        rowMenuRef.current.toggle(e);
                    }}
                />
            </div>
        );
    };

    const onHideSidebar = () => {
        setSidebarVisible(false);
        setIsEditing(false);
        setEditData(null);
        setEditAble(false);
    };

      const onPageChange = (event) => {
        const newPage = Math.floor(event.first / event.rows) + 1;
        setFirst(event.first);
        setRows(event.rows);
        setPage(newPage);
        fetchFeesData(newPage);
    };
    const template1 = {
            layout: 'CurrentPageReport',
            CurrentPageReport: (options) => {
                return (
                    <span style={{ color: 'var(--text-color)', userSelect: 'none', textAlign: 'left', fontSize: '12px', fontWeight: '400' }}>
                        Showing{' '}
                        <span style={{ fontWeight: '700' }}>
                            {options.first} - {Math.min(options.first + options.rows - 1, options.totalRecords)}
                        </span>{' '}
                        from <span style={{ fontWeight: '700' }}>{options.totalRecords}</span> data
                    </span>
                );
            }
        };
    
        const template2 = {
            layout: 'PrevPageLink PageLinks NextPageLink',
            PrevPageLink: (options) => {
                return <Button icon="pi pi-chevron-left" className="p-button prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
            },
            PageLinks: (options) => {
                const isActive = options.currentPage === options.page;
                return (
                    <button
                        type="button"
                        className={`mx-1 px-4 py-2 ${isActive ? 'isActivePage' : 'notActivePage'}`}
                        onClick={options.onClick}
                        style={{
                            width: '40.08px',
                            height: '40.08px',
                            fontSize: '14px',
                            fontWeight: '600',
                            borderRadius: '8px',
                            margin: '2px',
                            border: 'none',
                            boxShadow: isActive ? '0px 7px 16px 0px #00000024' : 'none'
                        }}
                    >
                        {options.page + 1}
                    </button>
                );
            },
            NextPageLink: (options) => {
                return <Button icon="pi pi-chevron-right" className="p-button-text prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
            }
        };

    return (
        <>
            {showSuccess && <SuccessLoader />}
            <ConfirmDialog
                visible={deleteDialogVisible}
                onHide={() => setDeleteDialogVisible(false)}
                message="On clicking this, fee details will be removed from the system. Proceed further?"
                contentClassName="content-className"
                header="Delete Fee"
                headerClassName="text-black"
                icon={<img src={DeleteIcon} alt="Delete" />}
                acceptLabel="Sure"
                rejectLabel="Close"
                acceptClassName="accept-button"
                rejectClassName="reject-button"
                className="custom-confirm-dialog"
                accept={() => handleDelete(userToDelete)}
            />
            <div className="grid">
                <div className="col-12 flex flex-column">
                    <Sidebar
                        className="p-sidebar-md"
                        visible={sidebarVisible}
                        position="right"
                        onHide={onHideSidebar}
                        style={{ width: '30rem' }}
                        pt={{
                            header: { className: 'border-bottom-1' },
                            content: { className: 'p-0' }
                        }}
                        showCloseIcon={false}
                    >
                        <AddEditFitnessFee onHideSidebar={onHideSidebar} isEditing={isEditing} editData={editData} editAble={editAble} fetchFeesData={fetchFeesData} />
                    </Sidebar>
                    <div className="flex justify-content-between items-center">
                        <h2 className="text-lg font-semibold">Fitness Fee & Fine Management</h2>
                        <div className="flex items-center gap-2">
                            {/* <span className="p-input-icon-left">
                                <i className="pi pi-search" />
                                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." className="p-inputtext-sm rounded-input" />
                            </span> */}
                            <Button
                                label="Add New"
                                icon="pi pi-plus"
                                className="px-4 py-2 font-semibold"
                                style={{ backgroundColor: '#FF556A', border: 'none', borderRadius: '10px', width:'140px' }}
                                onClick={() => {
                                    setSidebarVisible(true);
                                    setIsEditing(false);
                                    setEditData(null);
                                    setEditAble(false);
                                }}
                            />
                        </div>
                    </div>
                    <div className="card mt-3">
                        <DataTable
                            globalFilterFields={['categoryName', 'gracePeriod', 'registrationFee', 'finePerDay']}
                            filters={filters}
                            header={header}
                            value={tableData}
                            className=" shadow-md rounded-xl datatable-tall"
                            loading={loading}
                            responsiveLayout="scroll"
                            scrollable
                            scrollHeight="100%"
                            stickyHeader
                            emptyMessage={
                                <div className="w-full text-center py-4">
                                    <i className="pi pi-search text-4xl text-gray-400 mb-2"></i>
                                    <p>No results found</p>
                                </div>
                            }
                        >
                            <Column field="categoryName" header="Vehicle Category" style={{ minWidth: '400px' }} />
                            <Column field="gracePeriod" header="Grace Period"  />
                            <Column 
                                                            field="expiryDuration" 
                                                            header="Certificate Validity" 
                                                            body={(rowData) => (
                                                                <span >
                                                                    {rowData.expiryDuration ? 
                                                                        `${rowData.expiryDuration} ${Number(rowData.expiryDuration) === 1 ? 'Year' : 'Years'}` : 
                                                                        '1 Year'}
                                                                </span>
                                                            )}
                                                            style={{ minWidth: '150px', textAlign: 'right' }}
                                                        />
                            <Column 
                                field="normalFee" 
                                header="Normal Fee" 
                                body={(rowData) => (
                                    <span className="fee-value">{Number(rowData.normalFee).toLocaleString()} PKR</span>
                                )}
                                
                            />
                            <Column 
                                field="fine" 
                                header="Fine" 
                                body={(rowData) => (
                                    <span className="fee-value">{Number(rowData.fine).toLocaleString()} PKR</span>
                                )}
                                
                            />
                            <Column 
                                field="renewalFee" 
                                header="Renewal Fee" 
                                body={(rowData) => (
                                    <span className="fee-value">{Number(rowData.renewalFee).toLocaleString()} PKR</span>
                                )}
                                
                            />
                            <Column header="Actions" body={(rowData) => actionBodyTemplate(rowData)} style={{ width: '100px', textAlign: 'center' }} />
                        </DataTable>
                            <div className="flex justify-content-between mb-3 sticky" style={{borderTop: '1px solid #efefef', marginTop: '90px'}}>
                            <Paginator template={template1} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" />
                            <Paginator template={template2} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} rowsPerPageOptions={[10, 25, 50]} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RegistrationFees;
